import React from 'react'

export const FormationRules = [
  {
    name: 'Regras de Formação',
    component: React.lazy(() => import('../../modules/student/FormationRules')),
    path: '/student/formation-rules',
    guards: ['allowOnlyStudent', 'allowOnlyLogged'],
  },
]
